import * as React from 'react';

import { PageWrapper } from 'src/components/pageWrapper';
import { SmileOutlined } from '@ant-design/icons';
import { resetInterviewState } from 'src/store/modules/interviewModule';
import { resetInvitationState } from 'src/store/modules/invitationModule';
import { useAppDispatch } from 'src/types/reduxHelpers';
import { useTranslation } from 'react-i18next';

interface InterviewCompletedPageProps {

}

export const InterviewCompletedPage: React.FC<InterviewCompletedPageProps> = (props) => {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(resetInterviewState());
        dispatch(resetInvitationState());
    }, []);

    return (
        <PageWrapper
            isNonIdeal={true}
            nonIdealHeader={t('Pages.InterviewCompletedPage.header')}
            nonIdealSubheader={t('Pages.InterviewCompletedPage.subheader')}
            nonIdealIconType={<SmileOutlined />}
        />
    );
};